import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

export const ShimmerButton = ({ children, onClick, className = "", disabled = false }) => {
    return (
        <motion.button
            onClick={onClick}
            disabled={disabled}
            className={cn(
                "relative px-10 py-4 overflow-hidden",
                "bg-primary/10 border border-primary",
                "font-inter text-sm tracking-[0.25em] uppercase",
                "text-primary",
                "rounded-sm",
                "disabled:opacity-50 disabled:cursor-not-allowed",
                className
            )}
            whileHover={{ 
                scale: 1.02,
                boxShadow: "0 0 40px hsl(43 66% 52% / 0.4)"
            }}
            whileTap={{ scale: 0.98 }}
        >
            {/* Shimmer animation overlay */}
            <motion.div
                className="absolute inset-0 pointer-events-none"
                style={{
                    background: "linear-gradient(90deg, transparent 0%, hsl(43 66% 52% / 0.3) 50%, transparent 100%)",
                    backgroundSize: "200% 100%"
                }}
                animate={{
                    backgroundPosition: ["200% 0%", "-200% 0%"]
                }}
                transition={{
                    duration: 3,
                    repeat: Infinity,
                    ease: "linear"
                }}
            />
            
            {/* Content */}
            <span className="relative z-10 flex items-center justify-center gap-3">
                <span className="text-lg">✧</span>
                {children}
                <span className="text-lg">✧</span>
            </span>
            
            {/* Border glow */}
            <motion.div
                className="absolute inset-0 rounded-sm pointer-events-none"
                animate={{
                    boxShadow: [
                        "0 0 15px hsl(43 66% 52% / 0.2), inset 0 0 15px hsl(43 66% 52% / 0.05)",
                        "0 0 25px hsl(43 66% 52% / 0.4), inset 0 0 25px hsl(43 66% 52% / 0.1)",
                        "0 0 15px hsl(43 66% 52% / 0.2), inset 0 0 15px hsl(43 66% 52% / 0.05)"
                    ]
                }}
                transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
            />
        </motion.button>
    );
};

export default ShimmerButton;
